import React, { useEffect, useState } from "react";
import { ReactComponent as SuccessCircleFilledIcon } from "../../assets/icons/check-circle.svg";
import { ReactComponent as FailedCircleFilledIcon } from "../../assets/icons/close-circle.svg";

const PoolCompletedDiv = ({ this_orderIsRefundedBool }) => {
  return (
    <div className="text-center mb-3">
      <div className="payment-success-container success">
        <div className="success-icon mb-2">
          {this_orderIsRefundedBool === true &&
            <>
              {<FailedCircleFilledIcon />}
              Cancelled & fully refunded
            </>
          }
          {this_orderIsRefundedBool === false &&
            <>
              {<SuccessCircleFilledIcon />}
              SuperCheckout completed
            </>
          }
        </div>
      </div>
    </div>
  );
};

export default PoolCompletedDiv;
